import { render, staticRenderFns } from "./OrgChart.vue?vue&type=template&id=681cedf6&scoped=true&"
import script from "./OrgChart.vue?vue&type=script&lang=js&"
export * from "./OrgChart.vue?vue&type=script&lang=js&"
import style0 from "./OrgChart.vue?vue&type=style&index=0&id=681cedf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681cedf6",
  null
  
)

export default component.exports